import React, { useState } from 'react';
import ExpenseList from '../components/ExpenseList';
import ExpenseForm from '../components/ExpenseForm';
import useWindowWidth from '../hooks/useWindowWidth';
import '../components/RevenueDesktop.css';
import '../components/ExpenseDesktop.css';
import '../components/MobileApp.css';

function ExpensesPage() {
  const [editingExpense, setEditingExpense] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const width = useWindowWidth();

  const handleEdit = (expense) => {
    setEditingExpense(expense);
    setShowForm(true);
  };

  const handleNewExpense = () => {
    setEditingExpense(null);
    setShowForm(true);
  };

  const handleSuccess = () => {
    setShowForm(false);
    setEditingExpense(null);
    setRefreshTrigger(prev => prev + 1);
  };

  const isDesktop = width >= 768;

  return (
    <div>
      {/* ── Desktop header ── */}
      {isDesktop && !showForm && (
        <div className="rv-page-header">
          <div className="rv-page-header-title">
            <h1>Despesas</h1>
            <p>Gerencie seus pagamentos e gastos</p>
          </div>
          <button className="rv-btn rv-btn-primary" onClick={handleNewExpense}>
            + Nova Despesa
          </button>
        </div>
      )}

      {/* ── Desktop: form replaces list ── */}
      {isDesktop ? (
        showForm ? (
          <div>
            <p className="rv-form-heading">{editingExpense ? 'Editar Despesa' : 'Nova Despesa'}</p>
            <ExpenseForm expense={editingExpense} onSuccess={handleSuccess} />
            <button className="btn btn-secondary mt-3" onClick={() => setShowForm(false)}>Cancelar</button>
          </div>
        ) : (
          <ExpenseList onEdit={handleEdit} refreshTrigger={refreshTrigger} onNewExpense={handleNewExpense} />
        )
      ) : (
        /* ── Mobile: lista sempre visível, formulário em bottom sheet ── */
        <>
          <ExpenseList onEdit={handleEdit} refreshTrigger={refreshTrigger} onNewExpense={handleNewExpense} />
          {showForm && (
            <>
              <div className="mapp-sheet-overlay" onClick={() => setShowForm(false)} />
              <div className="mapp-sheet">
                <div className="mapp-sheet-handle" />
                <div className="mapp-sheet-header">
                  <span className="mapp-sheet-title">
                    {editingExpense ? 'Editar Despesa' : 'Nova Despesa'}
                  </span>
                  <button className="mapp-sheet-close" onClick={() => setShowForm(false)}>✕</button>
                </div>
                <div className="mapp-sheet-body">
                  <ExpenseForm expense={editingExpense} onSuccess={handleSuccess} />
                </div>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
}

export default ExpensesPage;
